function normalizeContact(value) {
    const contact = String(value || '').trim();
    const telegram = contact.match(/^(?:https?:\/\/)?(?:www\.)?(?:t\.me|telegram\.me)\/@?([a-z0-9_]+)\/?(?:[?#].*)?$/i);
    if (telegram) return telegram[1];
    return contact.replace(/^@/, '');
}

function getContactUrl(value) {
    const contact = normalizeContact(value);
    if (!contact) return '';
    if (/^telegram_[1-9]\d*$/.test(contact)) return `tg://user?id=${contact.slice(9)}`;
    if (/^[a-z0-9_]+$/i.test(contact)) return `https://t.me/${contact}`;
    try {
        const url = new URL(contact);
        return ['https:', 'http:'].includes(url.protocol) ? url.href : '';
    } catch (error) {
        return '';
    }
}

function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, char => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[char]));
}

function renderContact(name, username, className = 'detail-value') {
    const url = getContactUrl(username);
    const label = escapeHtml(name || username || 'Не указан');
    return url
        ? `<a href="${escapeHtml(url)}" class="${className}" target="_blank" rel="noopener noreferrer">${label}</a>`
        : `<span class="${className}">${label}</span>`;
}

function parseDealAmount(value) {
    const normalized = String(value || '').replace(/[\s\u00a0₽]/g, '').replace(',', '.');
    return /^\d+(?:\.\d{1,2})?$/.test(normalized) ? Number(normalized) : 0;
}

export { normalizeContact, getContactUrl, escapeHtml, renderContact, parseDealAmount };
